import { render } from "./admin-user.vue?vue&type=template&id=35fbf127&scoped=true&ts=true"
import script from "./admin-user.vue?vue&type=script&lang=ts"
export * from "./admin-user.vue?vue&type=script&lang=ts"

import "./admin-user.vue?vue&type=style&index=0&id=35fbf127&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fbf127"]])

export default __exports__